/**
 *  ? url pada submenu menggunakan naming routes,
 *  ? kelompokkan menu Tata Usaha berdasarkan kategori fungsional
 */
export default [
  // 1. Penugasan & Perwalian
  {
    icon: "UserCheckIcon",
    menu: "Dosen Wali",
    url: "tu-dosen-wali",
    group: "Penugasan & Perwalian",
  },
  {
    icon: "BoxIcon",
    menu: "Kelas",
    url: "tu-kelas",
    group: "Penugasan & Perwalian",
  },
  {
    icon: "CalendarIcon",
    menu: "Jadwal Mengajar",
    url: "tu-jadwal-mengajar",
    group: "Penugasan & Perwalian",
  },

  // 2. Kurikulum & Perkuliahan
  {
    icon: "BookOpenIcon",
    menu: "Kurikulum",
    url: "tu-kurikulum",
    group: "Kurikulum & Perkuliahan",
  },
  {
    icon: "BookIcon",
    menu: "Matakuliah",
    url: "tu-matakuliah-plot-matakuliah",
    group: "Kurikulum & Perkuliahan",
  },
  {
    icon: "TrendingUpIcon",
    menu: "Rekap Perkuliahan",
    url: "tu-rekap-perkuliahan",
    group: "Kurikulum & Perkuliahan",
  },

  // 3. Data Mahasiswa & Presensi
  {
    icon: "UsersIcon",
    menu: "Mahasiswa",
    url: "tu-mahasiswa",
    group: "Data Mahasiswa & Presensi",
  },
  {
    icon: "ActivityIcon",
    menu: "Aktivitas Mahasiswa",
    url: "tu-aktivitas-mahasiswa",
    group: "Data Mahasiswa & Presensi",
  },
  {
    icon: "CheckSquareIcon",
    menu: "Nilai Dan Presensi",
    url: "nilai-presensi",
    group: "Data Mahasiswa & Presensi",
  },

  // 4. Integrasi & Kerjasama
  {
    icon: "Share2Icon",
    menu: "Kerjasama",
    url: "tu-kerjasama",
    group: "Integrasi & Kerjasama",
  },
];
